"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeseriesResource = void 0;
exports.TimeseriesResource = {
    CaloriesActive: "calories_active",
    CaloriesBasal: "calories_basal",
    Distance: "distance",
    BloodOxygen: "blood_oxygen",
    BloodPressure: "blood_pressure",
    BodyFat: "body_fat",
    BodyWeight: "body_weight",
    Cholesterol: "cholesterol",
    CholesterolLdl: "cholesterol/ldl",
    CholesterolHdl: "cholesterol/hdl",
    CholesterolTotal: "cholesterol/total",
    CholesterolTriglycerides: "cholesterol/triglycerides",
    ElectrocardiogramVoltage: "electrocardiogram_voltage",
    FloorsClimbed: "floors_climbed",
    Glucose: "glucose",
    Heartrate: "heartrate",
    Hrv: "hrv",
    Hypnogram: "hypnogram",
    Ige: "ige",
    Igg: "igg",
    RespiratoryRate: "respiratory_rate",
    Steps: "steps",
    StressLevel: "stress_level",
    Vo2Max: "vo2_max",
    Water: "water",
    Caffeine: "caffeine",
    MindfulnessMinutes: "mindfulness_minutes",
};
